/**
 * Project grid — filter columns by project_phase (same UX as gallery filters).
 */

class ProjectGridBlock {
	constructor(root) {
		this.root = root;
		this.grid = root.querySelector('.project-grid-columns');
		this.filters = root.querySelectorAll('.project-grid-filter-btn');
		this.items = root.querySelectorAll('.project-grid-item');
		this.current = 'all';
		this.init();
	}

	init() {
		this.filters.forEach((btn) => {
			btn.addEventListener('click', () => this.applyFilter(btn.dataset.phase || 'all'));
		});
	}

	applyFilter(phase) {
		this.current = phase;

		this.filters.forEach((b) => b.classList.toggle('active', (b.dataset.phase || 'all') === phase));

		this.items.forEach((item) => {
			const raw = item.dataset.phases || 'none';
			const slugs = raw.split(',').map((s) => s.trim()).filter(Boolean);
			const show = phase === 'all' || slugs.includes(phase);
			item.hidden = !show;
			item.style.display = show ? '' : 'none';
		});

		requestAnimationFrame(() => {
			document.dispatchEvent(new CustomEvent('project-grid:filtered', {
				detail: { grid: this.root },
			}));
		});
	}
}

function initProjectGrids() {
	document.querySelectorAll('.block-project-grid').forEach((el) => {
		if (el.dataset.projectGridInit === '1') {
			return;
		}
		el.dataset.projectGridInit = '1';
		new ProjectGridBlock(el);
	});
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initProjectGrids);
} else {
	initProjectGrids();
}

document.addEventListener('project-grid:reinit', initProjectGrids);

export default ProjectGridBlock;
